import React, { FC, useState, useEffect } from "react";
import { MdOutlineErrorOutline } from "react-icons/md";
import { VscCloudDownload } from "react-icons/vsc";
import AccountCircle from "@mui/icons-material/AccountCircle";
import RegisterModal from "../../../components/ModalComponents/RegisterModal";
import { useAppDispatch, useAppSelector } from "../../../useStore";
import { getallReguser, reset } from "../../../features/Registration/registrationSlice";
import { headerTitles } from "../../../components/JobInputData";
import { EntriesPerPage, TableProgressBar } from "../../../components/TableOptions";
import Pagination from "../../../components/Pagination";
import swal from "sweetalert";
import { Toaster } from "react-hot-toast";

interface Props {
  pageHeader?: any;
  headerTitles: Array<string>;
  setData: any;
}
const RegisterTable: FC<Props> = ({ pageHeader, setData }) => {
  const dispatch = useAppDispatch();
  const { dataAll, isErrorAll, messageAll, isLoadingALl } = useAppSelector(
    (state: { registration: any }) => state.registration
  );
  const { isSuccess } = useAppSelector((state: { registration: any; }) => state.registration)

  useEffect(() => {
    if (isSuccess) {
      dispatch(getallReguser());
    }
    dispatch(getallReguser());
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (isErrorAll) {
      swal({
        title: "error",
        text: messageAll,
        icon: "error",
      });
      dispatch(reset());
    }
  }, [dispatch, isErrorAll, messageAll]);

  const [entriesperpage, setEntriesPerPage] = useState(() => {
    return "8";
  });

  useEffect(() => {
    setData(dataAll?.data?.length);
  }, [dataAll?.data?.length, setData]);

  const [displayData, setDisplayData] = useState([]);

  return (
    <div>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 5000,
          error: {
            duration: 20000,
          },
        }}
      />
      <section className="md-ui component-data-table">
        <header className="main-table-header">
          <div className="main-table-search-container">
            <h1 className="table-header--title">{pageHeader}</h1>
            <input className="search__input" type="text" placeholder="Search" />
            <div>
              <EntriesPerPage
                data={dataAll?.data}
                entriesperpage={entriesperpage}
                setEntriesPerPage={setEntriesPerPage}
              />
            </div>

            <RegisterModal setShowModal={undefined} />
          </div>
        </header>
        <div className="main-table-wrapper">
          <table className="main-table-content">
            <thead className="data-table-header">
              <tr className="data-table-row">
                {headerTitles.map((title: any, i: any) => (
                  <td
                    className="table-datacell datatype-string headerTitles"
                    key={i}
                  >
                    {title}
                  </td>
                ))}
              </tr>
            </thead>
            <tbody className="data-table-content">
              {isLoadingALl ? (
                <tr>
                  <td className="table-msg" colSpan={12}>
                    <VscCloudDownload size={75} />
                    <p>Fetching request...</p>
                    <div id="container-progressbar-container">
                      <TableProgressBar />
                    </div>
                  </td>
                </tr>
              ) : displayData?.length === undefined ? (
                <tr>
                  <td className="table-msg" colSpan={12}>
                    <MdOutlineErrorOutline size={75} />
                    <p>No Record found!</p>
                  </td>
                </tr>
              ) : (
                displayData?.map((row: any, i: any) => (
                  <tr className="data-table-row" key={i}>
                    <td className="table-datacell datatype-string">
                      <AccountCircle />
                    </td>

                    <td className="table-datacell datatype-numeric">
                      {row.firstName}
                    </td>
                    <td className="table-datacell datatype-numeric">
                      {row.LastName}
                    </td>

                    <td className="table-datacell datatype-numeric">
                      {row.email}
                    </td>

                    <td className="table-datacell datatype-numeric">
                      {row.phoneNumber}
                    </td>

                    <td className="table-datacell datatype-string">
                      {row.role}
                    </td>
                    <td className="table-datacell datatype-numeric">
                      <button className="severity-low">
                        {row.isEnabled === true ? "Active" : "Deactivated"}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className="table-footer">
          <div>
            <Pagination
              setDisplayData={setDisplayData}
              data={dataAll?.data}
              entriesperpage={entriesperpage}
              Total={"Applicant"}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default RegisterTable;
